import React from "react";
import FeatureSection from "../components/FeatureSection";

const featureImage1 ="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810afd_Group%203.png";
const featureImage2 = "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe7ad7dbc7b89e74d8047f_Group%201000005213%20(1).png";
const featureImage3 ="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe7b80f233ff74e2d03b5e_businessman-surfing-information-internet%201.png";

function TeamPage() {
  return (
    <div className="flex flex-col">
      {/* Section 1 */}
      <FeatureSection
        image={featureImage1}
        title="
      Power Up Your People: Team Performance Made Visible

          "
        description="
Your team is your most valuable asset. Zola gives you a clear view into how every employee is performing—so you can reward top performers, support growth, and keep your standards high across every location.
      
          
          "
        reverse

      />

      {/* Section 2 */}
      <FeatureSection
        image={featureImage2}
        title="
      Track Individual & Team Metrics in Real Time


          "
        description="
Celebrate wins with data you can trust. Zola highlights your highest-rated team members so you can recognize great service, boost morale, and keep your culture strong.
      
          "
      />

      {/* Section 3 */}
      <FeatureSection
        image={featureImage3}
        title="
      Spot Issues Before They Impact Customers
          "
        description="
Early warnings = fewer bad reviews. Zola helps you identify underperformance or repeated complaints early, so you can address them quickly and protect your reputation.
      
          "
        reverse

      />
    </div>
  );
}

export default TeamPage;
